'use client';

import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import { WorkspaceCreationForm } from '@/features/user-onboarding/components/screens/workspace-create-screen';

import {
	ONBOARDING_SCREEN_HEADERS,
	OnboardingScreen,
} from '../../constants/user-onboarding-constants';
import { BaseOnboardingModal } from './base-onboarding-modal';

interface WorkspaceModalProps {
	open: boolean;
	onWorkspaceCreated: (workspaceId: string) => void;
}

export function WorkspaceModal({ open, onWorkspaceCreated }: WorkspaceModalProps) {
	return (
		<BaseOnboardingModal open={open}>
			<DialogHeader className="flex flex-col items-start gap-2">
				<DialogTitle className="text-2xl">
					{ONBOARDING_SCREEN_HEADERS[OnboardingScreen.WORKSPACE_DETAILS].title}
				</DialogTitle>
				<DialogDescription>
					{ONBOARDING_SCREEN_HEADERS[OnboardingScreen.WORKSPACE_DETAILS]?.description}
				</DialogDescription>
			</DialogHeader>
			<WorkspaceCreationForm
				workspaceName=""
				onWorkspaceNameChange={() => {}}
				onSuccess={onWorkspaceCreated}
				showImageUpload={true}
				className="text-start"
			/>
		</BaseOnboardingModal>
	);
}
